import React, { ReactNode } from 'react';
import {
  InlineAlert
} from 'br2s-ui-componentlibrary_r2_02';
import './InlineAlertAdapter.scss';
import Richtext from '../Richtext/Richtext';

export interface InlineAlertProps {
  id: string;
  /**
    * What status is this Inline alert?
    */
  type?: 'informative' | 'success' | 'warning' | 'error';
  /**
    * Headline text
    */
  headline?: string;
  /**
    * Sub Headline text
    */
  subHeadline?: string;
  /**
    * Content of the Inline Alert
    */
  children: string;
}

function InlineAlertAdapter({
  id,
  type = 'informative',
  headline,
  subHeadline,
  children
}: InlineAlertProps) {
  return (
    <InlineAlert
      id={id}
      headline={headline}
      subHeadline={subHeadline}
      type={type}
    >
      <Richtext content={children} />
    </InlineAlert>
  );
}

export default InlineAlertAdapter;